module.exports = __webpack_public_path__ + "static/media/dropdown-icon-up.1b3bac38.svg";